import styled, { keyframes } from "styled-components";

const particleFloat = keyframes`
    0% {
        opacity: 0;
        transform: translateY(0) scale(0);
    }
    30% {
        opacity: 0.8;
        transform: translateY(-30px) scale(1);
    }
    100% {
        opacity: 0;
        transform: translateY(-100px) scale(0.5);
    }
`;

const slideUp = keyframes`
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

export const PageWrapper = styled.div`
    position: relative;
    width: 100%;
`;

export const ParticleContainer = styled.div`
    position: absolute;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
`;

export const Particle = styled.div<{
    size: number;
    top: string;
    left: string;
    delay: number;
    gradient: string;
}>`
    position: absolute;
    border-radius: 50%;
    width: ${({ size }) => size}px;
    height: ${({ size }) => size}px;
    background: ${({ gradient }) => gradient};
    top: ${({ top }) => top};
    left: ${({ left }) => left};
    animation: ${particleFloat} 1.5s ease-out forwards;
    animation-delay: ${({ delay }) => delay}s;
`;

export const SlideUpContent = styled.div<{ delay?: number }>`
    opacity: 0;
    animation: ${slideUp} 600ms ease-out forwards;
    animation-delay: ${({ delay }) => delay || 0}ms;
`;
